import { httpApi } from '@app/api/http.api';
import { IChannelBox, IChannelUnreadMessage } from '@app/interfaces/channel';
import { ChatQueryRequest } from '@app/interfaces/interfaces';

const baseSlug = '/channels';

export const getChatChannels = async (queryPayload: ChatQueryRequest | null): Promise<IChannelBox[]> => {
  try {
    let baseUrl = `${baseSlug}/chatChannels`;
    if (queryPayload) {
      baseUrl += `?${new URLSearchParams(queryPayload as Record<string, string>).toString()}`;
    }
    const { data } = await httpApi.get<IChannelBox[]>(baseUrl);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getUnreadMessage = async (): Promise<IChannelUnreadMessage> => {
  try {
    const { data } = await httpApi.get<IChannelUnreadMessage>(`${baseSlug}/unreadMessages`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};
